<template>
  <div class="collapse-wrapper">
    <el-collapse v-model="actives">
      <el-collapse-item title="基础信息" name="BASE">
        <el-form-item label="启动动作" label-width="120px" :rules="{ required: true, message: '请选择' }" >
          <el-select v-model.trim="model.doWhat" :disabled="disabled ||  tempModel.tempId !== undefined" @change="handleActionChange">
            <el-option v-for="(op, index) in doWhatOptions" :key="index" :value="op">{{ op }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用包名" label-width="120px">
          <el-input v-model.trim="model.packageName" :disabled="disabled"/>
        </el-form-item>
        <el-form-item label="启动方式" label-width="120px" :rules="{ required: true, message: '请选择' }" >
          <el-select v-model.trim="model.byWhat" :disabled="disabled ||  tempModel.tempId !== undefined">
            <el-option v-for="(op, index) in byWhatOptions" :key="index" :value="op">{{ op }}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启动参数" label-width="120px">
          <el-input v-model.trim="model.byValue" :disabled="disabled"/>
        </el-form-item>
        <template v-if="model.doWhat === 'skipAd'">
          <el-form-item label="按键跳过" label-width="120px">
            <el-input v-model.trim="model.text" :disabled="disabled" placeholder="请输入按键跳过文案"/>
          </el-form-item>
          <el-form-item label="显示时间" label-width="120px">
            <el-input v-model.number="model.showTime" :disabled="disabled" type="number" placeholder="请输入0-15的数字"/>
          </el-form-item>
        </template>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-model="extendActives" v-show="tempModel.tempId === undefined || model.paramsList.length > 0">
      <el-collapse-item title="扩展参数" name="EXTENTION">
        <div v-for="(item, index) in model.paramsList" :key="index" class="item-panel">
          <div v-if="paramName(item)" style="flex: 0 0 120px">{{ paramName(item) }}</div>
          <div v-else style="flex: 0 0 160px;">
            <el-input v-model.trim="item.key" placeholder="key" :disabled="disabled || paramName(item) !== undefined" clearable />
          </div>
          <div style="flex: auto;margin-left: 5px;">
            <PopLandingPageSelect
              v-if="paramName(item) === '落地页'"
              v-model="item.value"
              :disabled="disabled"
              :partnerId="partnerId"
              :placeholder="item.placeholder"
              @selected="function(row) {
                item.value = row.landingPageUrl
                $forceUpdate()
              }" />
            <el-input v-else v-model.trim="item.value" :placeholder="item.placeholder" :disabled="disabled" clearable />
          </div>
          <div style="margin: auto 5px;" v-if="!disabled && tempModel.tempId === undefined">
            <el-button v-if="model.paramsList.length > 0" @click="deleteParams(index)">删除</el-button>
          </div>
        </div>
        <div style="margin-top: 10px;" v-if="!disabled && tempModel.tempId === undefined">
          <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addParams">增加</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-model="privateExtendActives" v-show="tempModel.tempId === undefined || model.privateParams.length > 0">
      <el-collapse-item title="扩展参数(私有)" name="PRI_EXTENTION">
        <div v-for="(item, index) in model.privateParams" :key="index" class="item-panel">
          <div v-if="paramName(item, 'pri')" style="flex: 0 0 120px">{{ paramName(item, 'pri') }}</div>
          <div v-else style="flex: 0 0 160px;">
            <el-input v-model.trim="item.key" placeholder="key" :disabled="disabled || paramName(item, 'pri') !== undefined" clearable />
          </div>
          <div style="flex: auto;margin-left: 5px;">
            <PopLandingPageSelect
              v-if="paramName(item, 'pri') === '落地页'"
              v-model="item.value"
              :disabled="disabled"
              :partnerId="partnerId"
              :placeholder="item.placeholder"
              @selected="function(row) {
                item.value = row.landingPageUrl
                $forceUpdate()
              }" />
            <el-input v-else v-model.trim="item.value" :placeholder="item.placeholder" :disabled="disabled" clearable />
          </div>
          <div v-if="!disabled && tempModel.tempId === undefined" style="margin: auto 5px;">
            <el-button v-if="model.privateParams.length > 0" @click="delPrivateParams(index)">删除</el-button>
          </div>
        </div>
        <div v-if="!disabled && tempModel.tempId === undefined" style="margin-top: 10px;">
          <el-button size="small" type="primary" plain icon="el-icon-plus" @click="addPrivateParams">增加</el-button>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import PopLandingPageSelect from '@/components/PopLandingPageSelect.vue'

export default {
  components: {
    PopLandingPageSelect
  },
  props: {
    mode: { type: String, default: 'normal' },
    disabled: { type: Boolean, default: false },
    tempModel: { type: Object, default: () => ({}) },
    partnerId: { type: Number, default: 0 },
    model: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      actives: [],
      extendActives: ['EXTENTION'],
      privateExtendActives: ['PRI_EXTENTION']
    }
  },
  computed: {
    doWhatOptions() {
      if (this.mode === 'exception') {
        return ['startActivity', 'startWeb']
      }
      return ['startActivity', 'startService', 'skipAd', 'startWeb', 'startView', 'sendBroadcast']
    },
    byWhatOptions() {
      if (this.model.doWhat === 'startWeb') {
        return ['web']
      }
      if (this.model.doWhat === 'skipAd') {
        return ['action']
      }
      return ['uri', 'action', 'class', 'url']
    },
    paramName(param, type) {
      return function (param, type) {
        if (type === 'pri') {
          const privateParams = this.tempModel.privateParams ? JSON.parse(this.tempModel.privateParams) : []
          const paramTemp = privateParams.find(item => item.key === param.key)
          return paramTemp ? paramTemp.name : undefined
        } else {
          const paramList = this.tempModel.paramsList ? JSON.parse(this.tempModel.paramsList) : []
          const paramTemp = paramList.find(item => item.key === param.key)
          return paramTemp ? paramTemp.name : undefined
        }
      }
    }
  },
  methods: {
    handleActionChange(val) {
      if (val === 'startWeb') {
        this.model.byWhat = 'web'
      } else {
        this.model.byWhat = 'action'
      }
    },
    addParams() {
      this.model.paramsList.push({
        key: '',
        value: ''
      })
    },
    addPrivateParams() {
      this.model.privateParams.push({
        key: '',
        value: ''
      })
    },
    deleteParams(index) {
      this.model.paramsList.splice(index, 1);
    },
    delPrivateParams(index) {
      this.model.privateParams.splice(index, 1);
    }
  }
}
</script>

<style lang="stylus" scoped>
.collapse-wrapper .el-collapse
  margin-bottom 16px
  border 1px solid #EBEEF5
  border-radius 2px
  >>> .el-collapse-item__header
    padding-left 16px
    font-size 14px
    color #606266
  >>>.el-collapse-item.is-disabled .el-collapse-item__header
    color #606266
    .el-collapse-item__arrow
      display none
  >>>.el-collapse-item__content
    padding 10px 16px 25px
  .el-form-item
    margin-bottom 16px
    width 80%
.item-panel
  display flex
  margin-bottom 10px
  line-height 36px
  font-size 14px
  color #606266
.k-btn
  min-width 60px
</style>
